import { useState } from "react";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:ital,wght@0,300;0,400;0,500;1,300&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  body {
    font-family: 'DM Sans', sans-serif;
    background: #0a0a0f;
    min-height: 100vh;
    color: #e8e6f0;
  }

  .page {
    min-height: 100vh;
    background: #0a0a0f;
    position: relative;
    overflow: hidden;
  }

  .bg-grid {
    position: fixed;
    inset: 0;
    background-image:
      linear-gradient(rgba(220,38,38,0.04) 1px, transparent 1px),
      linear-gradient(90deg, rgba(220,38,38,0.04) 1px, transparent 1px);
    background-size: 48px 48px;
    pointer-events: none;
  }

  .bg-glow {
    position: fixed;
    top: -200px;
    left: 50%;
    transform: translateX(-50%);
    width: 700px;
    height: 500px;
    background: radial-gradient(ellipse, rgba(220,38,38,0.12) 0%, transparent 70%);
    pointer-events: none;
  }

  .container {
    max-width: 680px;
    margin: 0 auto;
    padding: 60px 24px 80px;
    position: relative;
    z-index: 1;
  }

  .header {
    margin-bottom: 48px;
  }

  .badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: rgba(220,38,38,0.12);
    border: 1px solid rgba(220,38,38,0.3);
    border-radius: 100px;
    padding: 6px 14px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #f87171;
    margin-bottom: 24px;
  }

  .badge-dot {
    width: 6px; height: 6px;
    background: #ef4444;
    border-radius: 50%;
    animation: pulse-dot 2s infinite;
  }

  @keyframes pulse-dot {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.5; transform: scale(0.8); }
  }

  .title {
    font-family: 'Syne', sans-serif;
    font-size: clamp(32px, 5vw, 46px);
    font-weight: 800;
    line-height: 1.1;
    letter-spacing: -0.02em;
    color: #f5f3ff;
    margin-bottom: 14px;
  }

  .title span {
    color: #ef4444;
  }

  .subtitle {
    font-size: 15px;
    font-weight: 300;
    color: #7c7a8e;
    line-height: 1.6;
    max-width: 480px;
  }

  .subtitle a {
    color: #a78bfa;
    text-decoration: none;
    border-bottom: 1px solid rgba(167,139,250,0.3);
  }

  .card {
    background: rgba(255,255,255,0.03);
    border: 1px solid rgba(255,255,255,0.08);
    border-radius: 20px;
    padding: 36px;
    margin-bottom: 20px;
    backdrop-filter: blur(10px);
    transition: border-color 0.2s;
  }

  .card:hover {
    border-color: rgba(255,255,255,0.13);
  }

  .card-title {
    font-family: 'Syne', sans-serif;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #6b6880;
    margin-bottom: 24px;
  }

  .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  @media (max-width: 520px) {
    .form-row { grid-template-columns: 1fr; }
  }

  .field {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
  }

  .field:last-child { margin-bottom: 0; }

  .field-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  @media (max-width: 520px) {
    .field-row { grid-template-columns: 1fr; }
  }

  label {
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.06em;
    color: #9896aa;
    text-transform: uppercase;
  }

  .required { color: #ef4444; margin-left: 2px; }

  input, textarea, select {
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 10px;
    padding: 13px 16px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    color: #e8e6f0;
    outline: none;
    transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
    width: 100%;
  }

  input::placeholder, textarea::placeholder {
    color: #3d3b4f;
  }

  input:focus, textarea:focus, select:focus {
    border-color: rgba(167,139,250,0.5);
    background: rgba(167,139,250,0.05);
    box-shadow: 0 0 0 3px rgba(167,139,250,0.08);
  }

  input.filled, textarea.filled {
    border-color: rgba(167,139,250,0.3);
    background: rgba(167,139,250,0.04);
  }

  textarea {
    resize: vertical;
    min-height: 90px;
  }

  select {
    appearance: none;
    cursor: pointer;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='%236b6880' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 16px center;
    padding-right: 40px;
    color: #e8e6f0;
  }

  select option {
    background: #1a1825;
    color: #e8e6f0;
  }

  .warning-card {
    background: rgba(220,38,38,0.06);
    border: 1px solid rgba(220,38,38,0.2);
    border-radius: 14px;
    padding: 20px 24px;
    margin-bottom: 20px;
    display: flex;
    gap: 16px;
    align-items: flex-start;
  }

  .warning-icon {
    width: 36px; height: 36px;
    flex-shrink: 0;
    background: rgba(220,38,38,0.15);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
  }

  .warning-text strong {
    font-family: 'Syne', sans-serif;
    font-size: 13px;
    font-weight: 700;
    color: #fca5a5;
    display: block;
    margin-bottom: 5px;
  }

  .warning-text p {
    font-size: 13px;
    font-weight: 300;
    color: #9896aa;
    line-height: 1.55;
  }

  .checkbox-field {
    display: flex;
    gap: 12px;
    align-items: flex-start;
    padding: 18px 0;
    border-top: 1px solid rgba(255,255,255,0.06);
    cursor: pointer;
  }

  .checkbox-field:first-of-type {
    border-top: none;
  }

  .custom-checkbox {
    width: 18px; height: 18px;
    flex-shrink: 0;
    border: 1.5px solid rgba(255,255,255,0.15);
    border-radius: 5px;
    margin-top: 1px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s;
    background: transparent;
    cursor: pointer;
  }

  .custom-checkbox.checked {
    background: #ef4444;
    border-color: #ef4444;
  }

  .custom-checkbox.checked::after {
    content: '';
    width: 5px; height: 8px;
    border: 1.5px solid white;
    border-top: none;
    border-left: none;
    transform: rotate(40deg) translateY(-1px);
    display: block;
  }

  .checkbox-label {
    font-size: 13.5px;
    font-weight: 400;
    color: #8886a0;
    line-height: 1.5;
    cursor: pointer;
  }

  .checkbox-label strong {
    color: #c4c2d4;
    font-weight: 500;
  }

  .btn-delete {
    width: 100%;
    padding: 17px;
    background: linear-gradient(135deg, #dc2626, #b91c1c);
    border: none;
    border-radius: 12px;
    font-family: 'Syne', sans-serif;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.04em;
    color: white;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    transition: all 0.2s;
    position: relative;
    overflow: hidden;
  }

  .btn-delete::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(255,255,255,0.1), transparent);
    opacity: 0;
    transition: opacity 0.2s;
  }

  .btn-delete:hover::before { opacity: 1; }
  .btn-delete:hover { transform: translateY(-1px); box-shadow: 0 8px 24px rgba(220,38,38,0.35); }
  .btn-delete:active { transform: translateY(0); }

  .btn-cancel {
    width: 100%;
    padding: 16px;
    background: transparent;
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 12px;
    font-family: 'Syne', sans-serif;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.04em;
    color: #7c7a8e;
    cursor: pointer;
    margin-top: 10px;
    transition: all 0.2s;
  }

  .btn-cancel:hover {
    border-color: rgba(255,255,255,0.2);
    color: #c4c2d4;
  }

  .actions { margin-top: 8px; }

  .divider {
    text-align: center;
    font-size: 12px;
    color: #3d3b4f;
    margin: 10px 0;
    font-weight: 500;
    letter-spacing: 0.05em;
  }

  .contact-footer {
    margin-top: 36px;
    text-align: center;
    padding: 20px;
    border-top: 1px solid rgba(255,255,255,0.06);
  }

  .contact-footer p {
    font-size: 12.5px;
    color: #4d4b60;
    font-weight: 300;
  }

  .contact-footer a {
    color: #7c6fdb;
    text-decoration: none;
    font-weight: 500;
    border-bottom: 1px solid rgba(124,111,219,0.3);
    transition: color 0.15s;
  }

  .contact-footer a:hover { color: #a78bfa; }

  .success-overlay {
    position: fixed;
    inset: 0;
    background: rgba(10,10,15,0.92);
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(8px);
    animation: fadeIn 0.3s ease;
  }

  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }

  .success-box {
    background: #12111a;
    border: 1px solid rgba(255,255,255,0.1);
    border-radius: 24px;
    padding: 48px 40px;
    text-align: center;
    max-width: 400px;
    width: 90%;
    animation: slideUp 0.35s cubic-bezier(0.34,1.56,0.64,1);
  }

  @keyframes slideUp { from { opacity: 0; transform: translateY(30px) scale(0.95); } to { opacity: 1; transform: none; } }

  .success-icon {
    width: 64px; height: 64px;
    background: rgba(220,38,38,0.12);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    margin: 0 auto 24px;
  }

  .success-box h3 {
    font-family: 'Syne', sans-serif;
    font-size: 22px;
    font-weight: 800;
    color: #f5f3ff;
    margin-bottom: 10px;
  }

  .success-box p {
    font-size: 14px;
    color: #7c7a8e;
    line-height: 1.6;
    font-weight: 300;
  }

  .success-box .ref {
    margin-top: 18px;
    font-size: 12px;
    color: #4d4b60;
    font-family: monospace;
    background: rgba(255,255,255,0.04);
    padding: 8px 14px;
    border-radius: 8px;
    display: inline-block;
  }
`;

const generateRef = () => "DEL-" + Math.random().toString(36).substr(2, 8).toUpperCase();

export default function DeleteAccountPage() {
  const [form, setForm] = useState({
    name: "", email: "", mobile: "", address: "", otherData: "", reason: ""
  });
  const [checks, setChecks] = useState({ understand: false, confirm: false });
  const [submitted, setSubmitted] = useState(false);
  const [refId] = useState(generateRef);

  const update = (k, v) => setForm(p => ({ ...p, [k]: v }));
  const toggleCheck = k => setChecks(p => ({ ...p, [k]: !p[k] }));

  const canSubmit = form.name && form.email && form.reason && checks.understand && checks.confirm;

  return (
    <>
      <style>{styles}</style>
      <div className="page">
        <div className="bg-grid" />
        <div className="bg-glow" />

        {submitted && (
          <div className="success-overlay">
            <div className="success-box">
              <div className="success-icon">🗑️</div>
              <h3>Request Submitted</h3>
              <p>Your deletion request has been received. We'll process it within 7–30 business days and confirm via email.</p>
              <div className="ref">Reference: {refId}</div>
            </div>
          </div>
        )}

        <div className="container">
          <div className="header">
            <div className="badge">
              <span className="badge-dot" />
              Data Deletion Request
            </div>
            <h1 className="title">Delete Your <span>Account</span></h1>
            <p className="subtitle">
              Fill in the details below to request permanent deletion of your personal data from our systems.
              For support, reach us at <a href="mailto:aivimart8@gmail.com">aivimart8@gmail.com</a>
            </p>
          </div>

          {/* Personal Info */}
          <div className="card">
            <div className="card-title">Your Information</div>

            <div className="field-row">
              <div className="field">
                <label>Name <span className="required">*</span></label>
                <input
                  type="text" placeholder="Full name"
                  value={form.name}
                  className={form.name ? "filled" : ""}
                  onChange={e => update("name", e.target.value)}
                />
              </div>
              <div className="field">
                <label>Email ID <span className="required">*</span></label>
                <input
                  type="email" placeholder="you@example.com"
                  value={form.email}
                  className={form.email ? "filled" : ""}
                  onChange={e => update("email", e.target.value)}
                />
              </div>
            </div>

            <div className="field">
              <label>Mobile Number</label>
              <input
                type="tel" placeholder="+91 00000 00000"
                value={form.mobile}
                className={form.mobile ? "filled" : ""}
                onChange={e => update("mobile", e.target.value)}
              />
            </div>

            <div className="field">
              <label>Address</label>
              <input
                type="text" placeholder="Your registered address"
                value={form.address}
                className={form.address ? "filled" : ""}
                onChange={e => update("address", e.target.value)}
              />
            </div>

            <div className="field" style={{ marginBottom: 0 }}>
              <label>Any Other Data in App</label>
              <textarea
                placeholder="Describe any other personal data stored in the app (e.g. order history, saved preferences, documents…)"
                value={form.otherData}
                className={form.otherData ? "filled" : ""}
                onChange={e => update("otherData", e.target.value)}
              />
            </div>
          </div>

          {/* Reason */}
          <div className="card">
            <div className="card-title">Reason for Deletion</div>
            <div className="field" style={{ marginBottom: 0 }}>
              <label>Request to Delete <span className="required">*</span></label>
              <select
                value={form.reason}
                onChange={e => update("reason", e.target.value)}
              >
                <option value="" disabled>Select a reason…</option>
                <option value="no_longer_use">I no longer use this app</option>
                <option value="privacy_concerns">Privacy / data concerns</option>
                <option value="switching_service">Switching to another service</option>
                <option value="too_many_emails">Too many communications</option>
                <option value="other">Other reason</option>
              </select>
            </div>
          </div>

          {/* Warning */}
          <div className="warning-card">
            <div className="warning-icon">⚠️</div>
            <div className="warning-text">
              <strong>This action is permanent and irreversible</strong>
              <p>Deleting your account will permanently erase all your personal data, order history, saved preferences, and access credentials. This cannot be undone.</p>
            </div>
          </div>

          {/* Confirmations */}
          <div className="card">
            <div className="card-title">Confirmation</div>

            <div className="checkbox-field" onClick={() => toggleCheck("understand")}>
              <div className={`custom-checkbox ${checks.understand ? "checked" : ""}`} />
              <span className="checkbox-label">
                I understand that <strong>all my data will be permanently deleted</strong> and this action cannot be reversed.
              </span>
            </div>

            <div className="checkbox-field" onClick={() => toggleCheck("confirm")}>
              <div className={`custom-checkbox ${checks.confirm ? "checked" : ""}`} />
              <span className="checkbox-label">
                I confirm that the information provided above is accurate and this is <strong>my own account</strong>.
              </span>
            </div>
          </div>

          {/* Actions */}
          <div className="actions">
            <button
              className="btn-delete"
              disabled={!canSubmit}
              style={{ opacity: canSubmit ? 1 : 0.4, cursor: canSubmit ? "pointer" : "not-allowed" }}
              onClick={() => canSubmit && setSubmitted(true)}
            >
              🗑️ Submit Deletion Request
            </button>
            <div className="divider">or</div>
            <button className="btn-cancel">Cancel — Keep My Account</button>
          </div>

          <div className="contact-footer">
            <p>For delays or further queries, contact us at <a href="mailto:aivimart8@gmail.com">aivimart8@gmail.com</a></p>
          </div>
        </div>
      </div>
    </>
  );
}